<template>
  <div class="c-avatar">
    <img v-if="imgUrl" :src="imgUrl" :alt="userName" />
    <div class="c-avatar__placeholder" :title="initials">
      {{ initials }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getInitials } from '@/utils/user';

interface AvatarProps {
  userName?: string;
  imgUrl?: string;
}

const props = withDefaults(defineProps<AvatarProps>(), {
  userName: 'Anonymous',
});

const initials = computed(() => getInitials(props.userName));
</script>
